import { Navigate, useParams } from "react-router-dom";
import { useAuthenticatedSession } from "../session";
import { EntrepriseLayout } from "./EntrepriseLayout";
import { consultantFeuillePath, esnFeuillePath } from "./routes";

/**
 * La route `/feuilles/:sheetId` est celle des courriels : un même lien sert
 * au consultant, au client et à l'ESN. Le serveur ne sait pas qui l'ouvrira ;
 * c'est la session qui tranche ici. Un consultant et un compte ESN sont
 * renvoyés vers la même feuille dans leur espace ; une entreprise la lit sur
 * place, sous sa propre coquille.
 */
export function FeuilleAiguillage() {
  const { sheetId = "" } = useParams();
  const { user } = useAuthenticatedSession();
  if (user.role === "consultant") {
    return <Navigate to={consultantFeuillePath(sheetId)} replace />;
  }
  if (user.role === "esn_admin" || user.role === "commercial") {
    return <Navigate to={esnFeuillePath(sheetId)} replace />;
  }
  return <EntrepriseLayout />;
}
